import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Role } from '@gen-common/enums';
import { environment } from 'src/environments/environment';

import { AuthService } from './auth.service';

@Component({
  standalone: true,
  template: ''
})
export class RootRedirectComponent {
  ROUTES_BY_ROLE = {
    [Role.CLEANER]: '/cleaning-mobile',
    [Role.TECHNICIAN]: '/task-mobile'
  };

  constructor() {
    const auth = inject(AuthService);
    const router = inject(Router);

    const defaultRoute = environment.defaultRoute ?? '/home';

    void auth
      .loadUser()
      .then((user) => {
        if (!user) {
          return false;
        }

        const roles = auth.roles;
        return router.navigateByUrl(roles.length === 1 && this.ROUTES_BY_ROLE[roles[0]] ? this.ROUTES_BY_ROLE[roles[0]] : defaultRoute);
      })
      .catch((error) => {
        console.error('Error loading user for root redirect:', error);
      });
  }
}
